import AppLayout from "@/layout";
import HomeLayout from "@/views/home/index.vue";

/*
 module对应后台产品定义的产品编码，子路由的module是父路由的产品编码 不匹配的话刷新后父菜单高亮会掉
*/
export default [
  {
    path: "",
    redirect: { name: "login" },
  },
  {
    path: "/home",
    name: "home",
    component: HomeLayout,
    meta: { title: "高标准农田遥感监测平台" },
  },
  {
    path: "/land",
    name: "land",
    redirect: { name: "land_manage" },
    component: AppLayout,
    meta: { title: "地块管理" },
    children: [
      {
        path: "manage",
        name: "land_manage",
        meta: { title: "地块管理", module: "landManage" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/land_manage"
          ),
      },
    ],
  },
  {
    path: "/non",
    name: "non",
    redirect: { name: "non_farm" },
    component: AppLayout,
    meta: { title: "非粮监测" },
    children: [
      {
        path: "farm",
        name: "non_farm",
        meta: { title: "非粮监测", module: "nonFarm" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/non_farm"
          ),
      },
    ],
  },
  {
    path: "/crop",
    name: "crop",
    redirect: { name: "crop_distribution" },
    component: AppLayout,
    meta: { title: "作物分布" },
    children: [
      {
        path: "distribution",
        name: "crop_distribution",
        meta: { title: "作物分布", module: "cropDistribution" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/crop_distribution"
          ),
      },
    ],
  },
  {
    path: "/farming",
    name: "farming",
    redirect: { name: "farming_land_soil" },
    component: AppLayout,
    meta: { title: "长势监测" },
    children: [
      {
        path: "land_soil",
        name: "farming_land_soil",
        meta: { title: "苗情监测", module: "landSoil" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/farming"
          ),
      },
      {
        path: "land_ndvi",
        name: "farming_land_ndvi",
        meta: { title: "归一化差异植被指数", module: "landNdvi" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/farming"
          ),
      },
      {
        path: "land_lai",
        name: "farming_land_lai",
        meta: { title: "叶面积指数", module: "landLai" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/farming"
          ),
      },
      {
        path: "land_gci",
        name: "farming_land_gci",
        meta: { title: "绿色叶绿素植被指数", module: "landGci" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/farming"
          ),
      },
      {
        path: "land_ave",
        name: "farming_land_ave",
        meta: { title: "植株氮含量", module: "landAve" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/farming"
          ),
      },

    ],
  },
  {
    path: "/landQuality",
    name: "landQuality",
    redirect: { name: "landQuality_den" },
    component: AppLayout,
    meta: { title: "耕地质量" },
    children: [
      {
        path: "den",
        name: "landQuality_den",
        meta: { title: "耕地质量等级", module: "landQualityDen" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/land"
            ),
      },
      {
        path: "yjz",
        name: "landQuality_yjz",
        meta: { title: "土壤有机质", module: "landQualityYjz" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/land"
            ),
      },
      {
        path: "dan",
        name: "landQuality_dan",
        meta: { title: "土壤氮含量", module: "landQualityDan" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/land"
          ),
      },
      {
        path: "lin",
        name: "landQuality_lin",
        meta: { title: "土壤有效磷", module: "landQualityLin" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/land"
          ),
      },
      {
        path: "jia",
        name: "landQuality_jia",
        meta: { title: "土壤速效钾", module: "landQualityJia" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/land"
          ),
      },

      {
        path: "ph",
        name: "landQuality_ph",
        meta: { title: "土壤pH值", module: "landQuality" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/land"
          ),
      },
    ],
  },
  {
    path: "/build",
    name: "build",
    redirect: { name: "build_facility" },
    component: AppLayout,
    meta: { title: "建设监管" },
    children: [
      {
        path: "facility",
        name: "build_facility",
        meta: { title: "建设监管", module: "buildFacility" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/build_facility"
          ),
      },
    ],
  },
  {
    path: "/project",
    name: "project",
    redirect: { name: "project_manage" },
    component: AppLayout,
    meta: { title: "项目管理" },
    children: [
      {
        path: "manage",
        name: "project_manage",
        meta: { title: "项目管理", module: "project_manage" },
        component: () =>
          import(
            /* webpackChunkName: "land-moisture" */ "@/views/highStandard/project_manage"
          ),
      },
    ],
  },
  {
    path: "/screen",
    name: "screen",
    component: () => import(/* webpackChunkName: "screen" */ "@/views/screen"),
    meta: { title: "数据大屏" },
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ "@/views/login"),
    meta: { title: "登录" },
  },
  {
    path: "*",
    redirect: { name: "login" },
  },
];
